// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!./_fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!./_colors.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js!./_font-sizes.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js!./_font-weight.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../node_modules/css-loader/dist/cjs.js!./_dimensions.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../node_modules/css-loader/dist/cjs.js!./_miscellaneous.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../node_modules/css-loader/dist/cjs.js!./_preferences.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../node_modules/css-loader/dist/cjs.js!./roqChat/index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* If you need to check ROQ original css, uncomment this line */
/* and comment out the one above. */
/* @import '@roq/ui-react/dist/index.css'; */

:root {
  color-scheme: light;
}

html {
  box-sizing: border-box;
  -webkit-text-size-adjust: 100%;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

body {
  font-kerning: normal;
  font-size: var(--font-baseline);
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  word-wrap: break-word;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ol,
ul {
  font-weight: var(--font-weight-text);
  margin: 0;
  padding: 0;
}

dl,
ol,
ul {
  list-style: none;
}

li {
  outline: 0;
}

img {
  height: auto;
  max-width: 100%;
}

body,
input,
textarea,
button {
  font-family:
    'Montserrat',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    'Open Sans',
    'Helvetica Neue',
    sans-serif;
}

/**
 * Hide InjectManifest has been called multiple times warning
 */
body > iframe#webpack-dev-server-client-overlay {
  display: none;
}

strong {
  font-weight: var(--font-weight-strong);
}

a {
  color: inherit;
  outline: 0;
  text-decoration: none;
}

button {
  background-color: transparent;
  border: 0;
  color: inherit;
  outline: 0;
  padding: 0;
}

button:disabled {
  /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
  cursor: not-allowed;
}

:focus-visible:not(input) {
  box-shadow: var(--focus-shadow);
}

button,
input[type='submit'],
label {
  cursor: pointer;
}

input:focus {
  border: var(--border-outline);
  outline: none;
}

/* Reset table styles */
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  border: 0;
  font: inherit;
  font-size: 100%;
  margin: 0;
  padding: 0;
  vertical-align: baseline;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

/* Reset placeholders opacity because we are using custom colors (with opacity) for placeholders  */
input::placeholder,
textarea::placeholder {
  color: var(--color-placeholder);
  opacity: 1;
}

/* Custom scrollbar */
@media (min-width: 1024px) and (hover: hover),
  (min-width: 768px) and (hover: none) {
  * {
    /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
    scrollbar-color: var(--color-scrollbar-thumb) var(--color-scrollbar-track);
    /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
    scrollbar-width: thin;
  }

  *::-webkit-scrollbar {
    /* Add 0.2rem to fixed width so scrollbar will get wider when user zooms in */
    width: calc(var(--spacing-small) + 0.2em);
  }

  *::-webkit-scrollbar-corner,
  *::-webkit-resizer,
  *::-webkit-scrollbar-track {
    background: var(--color-scrollbar-track);
  }

  *::-webkit-scrollbar-thumb {
    background-color: var(--color-scrollbar-thumb);
    border: var(--border-scrollbar);
    border-radius: var(--border-radius-large);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/index.css"],"names":[],"mappings":"AAQA,+DAA+D;AAC/D,mCAAmC;AACnC,4CAA4C;;AAE5C;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,kCAAkC;EAClC,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;;;;;;;;;;EAUE,oCAAoC;EACpC,SAAS;EACT,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;EAIE;;;;;;;;;;;cAWY;AACd;;AAEA;;EAEE;AACF;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,cAAc;EACd,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,uEAAuE;EACvE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA,uBAAuB;AACvB;;;;;;;;EAQE,SAAS;EACT,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,mGAAmG;AACnG;;EAEE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA,qBAAqB;AACrB;;EAEE;IACE,uEAAuE;IACvE,0EAA0E;IAC1E,uEAAuE;IACvE,qBAAqB;EACvB;;EAEA;IACE,6EAA6E;IAC7E,yCAAyC;EAC3C;;EAEA;;;IAGE,wCAAwC;EAC1C;;EAEA;IACE,8CAA8C;IAC9C,+BAA+B;IAC/B,yCAAyC;EAC3C;AACF","sourcesContent":["@import './_fonts.css';\n@import './_colors.css';\n@import './_font-sizes.css';\n@import './_font-weight.css';\n@import './_dimensions.css';\n@import './_miscellaneous.css';\n@import './_preferences.css';\n@import './roqChat/index.css';\n/* If you need to check ROQ original css, uncomment this line */\n/* and comment out the one above. */\n/* @import '@roq/ui-react/dist/index.css'; */\n\n:root {\n  color-scheme: light;\n}\n\nhtml {\n  box-sizing: border-box;\n  -webkit-text-size-adjust: 100%;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n\nbody {\n  font-kerning: normal;\n  font-size: var(--font-baseline);\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  word-wrap: break-word;\n}\n\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nol,\nul {\n  font-weight: var(--font-weight-text);\n  margin: 0;\n  padding: 0;\n}\n\ndl,\nol,\nul {\n  list-style: none;\n}\n\nli {\n  outline: 0;\n}\n\nimg {\n  height: auto;\n  max-width: 100%;\n}\n\nbody,\ninput,\ntextarea,\nbutton {\n  font-family:\n    'Montserrat',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    Cantarell,\n    'Open Sans',\n    'Helvetica Neue',\n    sans-serif;\n}\n\n/**\n * Hide InjectManifest has been called multiple times warning\n */\nbody > iframe#webpack-dev-server-client-overlay {\n  display: none;\n}\n\nstrong {\n  font-weight: var(--font-weight-strong);\n}\n\na {\n  color: inherit;\n  outline: 0;\n  text-decoration: none;\n}\n\nbutton {\n  background-color: transparent;\n  border: 0;\n  color: inherit;\n  outline: 0;\n  padding: 0;\n}\n\nbutton:disabled {\n  /* stylelint-disable-next-line plugin/no-unsupported-browser-features */\n  cursor: not-allowed;\n}\n\n:focus-visible:not(input) {\n  box-shadow: var(--focus-shadow);\n}\n\nbutton,\ninput[type='submit'],\nlabel {\n  cursor: pointer;\n}\n\ninput:focus {\n  border: var(--border-outline);\n  outline: none;\n}\n\n/* Reset table styles */\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd {\n  border: 0;\n  font: inherit;\n  font-size: 100%;\n  margin: 0;\n  padding: 0;\n  vertical-align: baseline;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n/* Reset placeholders opacity because we are using custom colors (with opacity) for placeholders  */\ninput::placeholder,\ntextarea::placeholder {\n  color: var(--color-placeholder);\n  opacity: 1;\n}\n\n/* Custom scrollbar */\n@media (min-width: 1024px) and (hover: hover),\n  (min-width: 768px) and (hover: none) {\n  * {\n    /* stylelint-disable-next-line plugin/no-unsupported-browser-features */\n    scrollbar-color: var(--color-scrollbar-thumb) var(--color-scrollbar-track);\n    /* stylelint-disable-next-line plugin/no-unsupported-browser-features */\n    scrollbar-width: thin;\n  }\n\n  *::-webkit-scrollbar {\n    /* Add 0.2rem to fixed width so scrollbar will get wider when user zooms in */\n    width: calc(var(--spacing-small) + 0.2em);\n  }\n\n  *::-webkit-scrollbar-corner,\n  *::-webkit-resizer,\n  *::-webkit-scrollbar-track {\n    background: var(--color-scrollbar-track);\n  }\n\n  *::-webkit-scrollbar-thumb {\n    background-color: var(--color-scrollbar-thumb);\n    border: var(--border-scrollbar);\n    border-radius: var(--border-radius-large);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
